import React, { useState, useRef, useEffect } from 'react';
import "../App.css"
import MenuBar from '../layouts/MenuBar'
import { useSearchParams } from 'react-router-dom';
import WaitingForData from '../layouts/WaitingForData';
import { Link } from 'react-router-dom';
import { useTelemetry } from '../contexts/TelemetryContext';
import Telemetry from './components/Telemetry';
import { useDatabase } from '../contexts/DatabaseContext';


function App() {
  // Get query parameters
  const [searchParams] = useSearchParams();
  const carName = searchParams.get('CarName'); // Get ?car=Albyn1
  
  const { latestTelemetry } = useTelemetry()
  const {carsSettings } = useDatabase()

  const [settings,setSettings] = useState({})
  const [carTelemetry, setCarTelemetry] = useState({})

  useEffect(() => {
    if (carName && carsSettings) {
      const carSettings = carsSettings.find(car => car.dweet_name === carName);
      if (carSettings) {
        setSettings(carSettings);
      } 
  }}
  ,[carName, carsSettings]);

  useEffect(() => {
    if (carName && latestTelemetry) {
      const t = latestTelemetry?.[carName];
      if (t) {
        setCarTelemetry(t);
      } 
  }}
  ,[carName, latestTelemetry]);

  return (
    <>
      <MenuBar/>
      {(carTelemetry) ? 
        <Telemetry telemetry={carTelemetry} settings={settings} carName={carName}/>
      :
      (settings) ?
        <div className="w-75 mx-auto mt-5">
          <WaitingForData />
        </div>
      : 
        <div className="w-75 mx-auto mt-5">
          <Link to={`/configure?${4}`} className="btn btn-warning btn-block">Set Dweet Thing Name Here</Link>
        </div>
      }
    </>
  );
}
export default App;